module.exports = __webpack_public_path__ + "static/img/rizqia-ac-gree-authorized-dealer.ba956af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certificate/rizqia-ac-gree-authorized-dealer.jpg
// module id = Lbi8
// module chunks = 0